// client/src/routes/app/health/$propertyId.tsx — SCR-HS-002 „Detaliu scor proprietate" ·
// HS-003 (04 §8.13, §7's route tree — „app/health/$propertyId.tsx  # SCR-HS-002").
//
// The one route this item adds, and it is the one 04 §7 already lists by path. It carries no
// new nav key: `nav.health` points at SCR-HS-001 and this is reached from a row of its heat
// list, from a penalty's deep link, or from a shared URL.
//
// Two search params, both §9.2.3 overlays rather than filters: `component` names the open
// penalty drawer, `trendDays` is the sparkline's window and is the endpoint's own parameter.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { PropertyHealthScreen } from '@/features/health/PropertyHealthScreen';
import { propertyHealthSearchSchema } from '@/features/health/search';

export const Route = createFileRoute('/app/health/$propertyId')({
  validateSearch: propertyHealthSearchSchema,
  component: PropertyHealthRoute,
});

function PropertyHealthRoute() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Reports.Read">
      <PropertyHealthScreen
        propertyId={propertyId}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
